import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { DashboardLayout } from "../Layout/dashboard/DashboardLayout";
import { getClientConfig } from "../config/clientConfig";
import {
  getLandingPath,
  isPathAllowed,
} from "../Components/Sidebar/sidebar.config";
import { RootState } from "../store";

const OVERVIEW_PATH = "/overview";
const BUSINESS_CLIENTS_PATH = "/";
const CLIENT_USER_TYPE = 1;

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const clientConfig = getClientConfig();
  const location = useLocation();
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  const applicationType = useSelector(
    (state: RootState) => state.applicationType.applicationType,
  );
  const selectedClient = useSelector(
    (state: RootState) => state.selectedClient.selectedClient,
  );
  const userType = useSelector((state: RootState) => state.auth.userType);
  const resolvedUserType =
    userType === 565
      ? parseInt(localStorage.getItem("userType") || "565", 10)
      : userType;
  const isClientUser = resolvedUserType === CLIENT_USER_TYPE;
  const hasSelectedClient = Boolean(selectedClient) || isClientUser;
  const path = location.pathname;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const access = {
    roleId: isClientUser ? CLIENT_USER_TYPE : resolvedUserType,
    hasSelectedClient,
    applicationType,
  };

  if (!hasSelectedClient) {
    if (path !== BUSINESS_CLIENTS_PATH) {
      return <Navigate to={BUSINESS_CLIENTS_PATH} replace />;
    }
  } else if (!applicationType) {
    const canStayOnBusinessClients =
      !isClientUser && path === BUSINESS_CLIENTS_PATH;
    if (path !== OVERVIEW_PATH && !canStayOnBusinessClients) {
      return <Navigate to={OVERVIEW_PATH} replace />;
    }
  } else if (!isPathAllowed(path, access)) {
    return <Navigate to={getLandingPath(access)} replace />;
  }

  return (
    <DashboardLayout clientConfig={clientConfig}>{children}</DashboardLayout>
  );
};

export default ProtectedRoute;
